module.exports = __webpack_public_path__ + "src/assets/img/en.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en.svg
// module id = tc7e
// module chunks = 80